var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.8408 1.8335H7.15918C3.82251 1.8335 1.83334 3.82266 1.83334 7.15933V14.8318C1.83334 18.1777 3.82251 20.1668 7.15918 20.1668H14.8317C18.1683 20.1668 20.1575 18.1777 20.1575 14.841V7.15933C20.1667 3.82266 18.1775 1.8335 14.8408 1.8335Z",
    fill: "#D77910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69832 14.2816C9.51499 14.2816 9.34082 14.2083 9.21249 14.08L6.61832 11.4858C6.35249 11.22 6.35249 10.78 6.61832 10.5141C6.88415 10.2483 7.32415 10.2483 7.58999 10.5141L9.69832 12.6225L14.41 7.9108C14.6758 7.64497 15.1158 7.64497 15.3817 7.9108C15.6475 8.17663 15.6475 8.61663 15.3817 8.88247L10.1842 14.08C10.0558 14.2083 9.88165 14.2816 9.69832 14.2816Z",
    fill: "#D77910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSquare);
export default __webpack_public_path__ + "static/media/tick-square.2be81796d918a4c1ad1447bafe2c0af0.svg";
export { ForwardRef as ReactComponent };